import { render, staticRenderFns } from "./tabs.vue?vue&type=template&id=1308ab0a&lang=pug&"
import script from "./tabs.vue?vue&type=script&lang=js&"
export * from "./tabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1308ab0a')) {
      api.createRecord('1308ab0a', component.options)
    } else {
      api.reload('1308ab0a', component.options)
    }
    module.hot.accept("./tabs.vue?vue&type=template&id=1308ab0a&lang=pug&", function () {
      api.rerender('1308ab0a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/src/components/common/tabs.vue"
export default component.exports